import { createActions } from 'reduxsauce'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  // Get Voices
  voicesListRequest: ['provider'],
  voicesListSuccess: ['list'],
  voicesListFailure: ['error'],

  // Set selected voice
  setSelectedVoice: ['voice'],
  clearSelectedVoice: [],

  // Reset
  voicesReset: [],
})

export const VoiceTypes = Types
export default Creators

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
  // List
  list: [],
  listFetching: false,
  listError: null,

  // Selected voice
  selectedVoice: null,
}

/* ------------- Stable Default Values ------------- */
const EMPTY_ARRAY = []

/* ------------- Selectors ------------- */
export const VoiceSelectors = {
  getVoices: state => (state.voice.list && state.voice.list.length > 0) ? state.voice.list : EMPTY_ARRAY,
  isFetching: state => state.voice.listFetching,
  getError: state => state.voice.listError,
  getSelectedVoice: state => state.voice.selectedVoice || null,
}

/* ------------- Reducer ------------- */
export const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // List
    case Types.VOICES_LIST_REQUEST:
      return { ...state, listFetching: true, listError: null }
    case Types.VOICES_LIST_SUCCESS: {
      // Sanitize voice data to only store plain objects
      const sanitizedList = (action.list || []).map(v => ({
        voice_id: v.voice_id,
        name: v.name,
        category: v.category,
        gender: v.gender,
        accent: v.accent,
        description: v.description,
        preview_url: v.preview_url,
      }))
      return { ...state, list: sanitizedList, listFetching: false, listError: null }
    }
    case Types.VOICES_LIST_FAILURE:
      return { ...state, listFetching: false, listError: action.error }

    // Selected Voice
    case Types.SET_SELECTED_VOICE: {
      if (!action.voice) return { ...state, selectedVoice: null }
      // Sanitize to plain object
      const sanitizedVoice = {
        voice_id: action.voice.voice_id,
        name: action.voice.name,
        category: action.voice.category,
        gender: action.voice.gender,
        accent: action.voice.accent,
        description: action.voice.description,
        preview_url: action.voice.preview_url,
      }
      return { ...state, selectedVoice: sanitizedVoice }
    }
    case Types.CLEAR_SELECTED_VOICE:
      return { ...state, selectedVoice: null }

    // Reset
    case Types.VOICES_RESET:
      return { ...INITIAL_STATE }

    default:
      return state
  }
}
